/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { Link } from 'react-router';
import { ProgressBar } from 'react-bootstrap';
import styles from './styles.scss';

const propTypes = {
  icon: PropTypes.any.isRequired,
  name: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  value: PropTypes.any,
  total: PropTypes.any,
  bordered: PropTypes.bool,
};

const defaultProps = {
  value: 0,
  total: 10,
  bordered: false,
};

const Card = (props) => {
  const {
    icon,
    value,
    total,
    name,
    handleClick,
    bordered,
  } = props;

  return (
    <Link
      styleName={`card ${bordered ? 'bordered' : ''}`}
      onClick={handleClick}
    >
      <div className="media">
        <div className="media-left">
          <img alt="" className="media-object" src={icon} />
        </div>
        <div className="media-body">
          <h4 className="media-heading">{name}</h4>
          <p>{ value }{' / '} { total }</p>
        </div>
      </div>
      <ProgressBar bsStyle="aisz-primary" now={(value / total) * 100} />
    </Link>
  );
};

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;

export default CSSModules(Card, styles, { allowMultiple: true });




// WEBPACK FOOTER //
// ./src/containers/Overview/Count/index.jsx